import { splitTextAndMath, renderMathToString } from "@ever-tutor/et-ui";

export type TextSegment = { type: "text"; content: string };
export type LatexSegment = { type: "latex"; renderedHtml: string };
export type MessageSegment = TextSegment | LatexSegment;

// Input:   raw message string from AI, may contain LaTeX spans ($…$, $$…$$, \(…\), \[…\])
// Output:  ordered array of segments ready for React rendering
export function parseMessageSegments(text: string): MessageSegment[] {
  return splitTextAndMath(text).map((seg) =>
    seg.type === "text"
      ? { type: "text", content: seg.content }
      : {
          type: "latex",
          renderedHtml: renderMathToString(seg.latex, {
            displayMode: seg.display,
          }),
        },
  );
}
